<template>
  <div class="config-section">
    <div 
      class="section-header"
      @click="toggle"
      :class="{ expanded }"
    >
      <div class="section-title">
        <span class="section-icon">{{ icon }}</span>
        <h4>{{ title }}</h4>
      </div>
      <div class="section-actions">
        <button 
          v-if="collapsible"
          class="collapse-btn"
          :title="expanded ? '收起' : '展开'"
        >
          {{ expanded ? '▲' : '▼' }}
        </button>
      </div>
    </div>
    
    <Transition name="collapse">
      <div v-show="expanded" class="section-content">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'ConfigSection',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: '📋'
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    defaultExpanded: {
      type: Boolean,
      default: true
    }
  },
  
  setup(props) {
    const expanded = ref(props.defaultExpanded)
    
    const toggle = () => {
      if (props.collapsible) {
        expanded.value = !expanded.value
      }
    }
    
    return {
      expanded,
      toggle
    }
  }
}
</script>

<style scoped>
.config-section {
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #e9ecef;
}

.section-header:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
}

.section-header.expanded {
  border-bottom-color: #e9ecef;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  font-size: 20px;
}

.section-title h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
}

.section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.collapse-btn {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s;
}

.collapse-btn:hover {
  background: rgba(108, 117, 125, 0.1);
  color: #495057;
}

.section-content {
  padding: 20px;
  background: #fff;
}

/* 折叠动画 */
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.collapse-enter-from,
.collapse-leave-to {
  max-height: 0;
  opacity: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.collapse-enter-to,
.collapse-leave-from {
  max-height: 1000px;
  opacity: 1;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .section-header {
    padding: 12px 16px;
  }
  
  .section-content {
    padding: 16px;
  }
  
  .section-title h4 {
    font-size: 15px;
  }
  
  .section-icon {
    font-size: 18px;
  }
}
</style>
